
















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class List extends Vue {
  @Prop() private items!: object;
  @Prop() private itemclass!: string;
  @Prop() private listclass!: string;

  creationEnabled = false
  newSeedName = ''

  deleteItem (id) {
    this.$emit('delete', {
      id: id
    })
  }

  createNew () {
    if (this.creationEnabled) {
      this.$emit('create', {
        name: this.newSeedName
      })
    } else {
      this.creationEnabled = true
    }
  }
}
